export interface WidgetType {
  id: string;
  name: string;
  description: string;
  category: string;
  sizes: Array<'1x1' | '2x1' | '2x2'>;
  defaultSize: '1x1' | '2x1' | '2x2';
  icon: React.ComponentType<{ className?: string }>;
  supportsOrgScope: boolean;
  supportsProjectScope: boolean;
}

export interface WidgetProps {
  scope: 'org' | 'project';
  projectId?: string;
  config?: Record<string, any>;
  size: '1x1' | '2x1' | '2x2';
}

export const WIDGET_CATEGORIES = {
  FINANCIAL: 'Financial',
  PROJECTS: 'Projects',
  TASKS: 'Tasks & Work',
  DOCUMENTS: 'Documents & Files',
  REPORTS: 'Reports & Analytics',
  SAFETY: 'Safety & Compliance',
  EXTERNAL: 'External Data',
} as const;
